import React, {Component} from 'react';

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {
    prepareSelectOptionsList,
    actionsFormatter,priceFormatter,
    historyDataFormatter,    linkFormatter,
    dateFormatter,
    customFormatter,
    getFieldByPathFormatter
} from 'util/Utils';

  import config from  '../../../config';


class AdminInventoryReconListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
            currentRecord: {},

        };
        this.tableRef = null
    }

    customActionsFormatter(cell, row, extra) {
        var menuItemsMap = []
        if (_.includes( row.Name,'ServiceDateRules')   ) {
            menuItemsMap.push({onClick: 'editRecord', label: 'Edit'})
        }

        return actionsFormatter.call(this, cell, row, {menuItemsMap})
    }

    editRecord(row) {
        this.props.editRecord(row);
    }

 








    render() {
            console.log('Recon list table props', this.props  );
        return (
            <div className=" databases-table">
                <BootstrapTable data={this.props.tableData}
                                remote={ true }
                                hover={true}
                                condensed={true}
                                ref={(ref) => {
                                    if (!this.tableRef && ref) {
                                        this.tableRef = ref;

                                    }
                                }}

                                striped={true}
                                selectRow={{
                                    mode: 'checkbox',
                                    columnWidth: '29px',
                                    onSelect: this.props.onRowSelect,
                                    onSelectAll: this.props.onAllRowSelect,
                                    customComponent: this.props.customMultiSelect
                                }}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                } }

                >
                    <TableHeaderColumn width="50px"
                                       dataField='DisplayName' dataAlign="center"
                                       >Seller</TableHeaderColumn>
                    <TableHeaderColumn width="35px" f
                                        dataField='MarketName' dataAlign="center"  >Seller Location
                        </TableHeaderColumn>

                    <TableHeaderColumn dataAlign="center" width="40px" dataField='ProductsTotalNumber'
                                       dataFormat={(cell, row, extra)=>{
                                           if (_.get(row, extra.labelPath, 0) >0) {
                                               return linkFormatter(cell, row, extra)
                                           } else {
                                               return <div>{_.get(row, extra.labelPath, extra.label ? extra.label : 'Link')} </div>
                                           }

                                       } }
                                       formatExtraData={ {
                                           labelPath: ['ProductsTotalNumber'],
                                           path: 'getObject',
                                           formatPathValue:(row)=>{
                                               var recordIDs = _.map(_.get(row,  'SellerProductsListed',[]), item=>{
                                                   return  'recordIDs='+ encodeURIComponent(item._id)
                                               })
                                               return      recordIDs.join('&')
                                           },
                                           placeholder: '[queryParams]',
                                           template: config.getEnvironment().serverBaseURL +'/admin/products?[queryParams]',
                                       }  }
                    >Inventory Balance (#)</TableHeaderColumn>

                    <TableHeaderColumn width="60px"  formatExtraData={ {path:[  'ProductsTotalSum']}  }
                                       dataFormat={ priceFormatter } dataField='ProductsTotalSum'
                                       dataAlign="center"  >Inventory Balance ($)</TableHeaderColumn>

                    <TableHeaderColumn width="60px"  formatExtraData={ {path:[  'ProductsTotalCOGS']}  }
                                       dataFormat={ priceFormatter } dataField='ProductsTotalCOGS'
                                       dataAlign="center"  >Inventory Balance COGS ($)</TableHeaderColumn>

                    <TableHeaderColumn dataAlign="center" width="40px" dataField='SellerSaleTransactions'
                                       dataFormat={(cell, row, extra)=>{
                                            if(!_.get(row,[ 'SellerSaleTransactions',0, '_id'])) {
                                               return 0
                                           }
                                           var size =  row.SaleTransactionsTotalNumber = _.size(_.get(row,  'SellerSaleTransactions',[]))
                                            if (size ) {
                                              return linkFormatter(cell, row, extra)
                                           } else {
                                               return <div>{size} </div>
                                           }

                                       } }
                                       formatExtraData={ {
                                           labelPath: ['SaleTransactionsTotalNumber'],
                                           path: 'getObject',
                                           formatPathValue:(row)=>{
                                                var recordIDs = _.map(_.get(row,  'SellerSaleTransactions',[]), item=>{
                                                   return  'recordIDs='+ encodeURIComponent(item._id)
                                               })
                                               return      recordIDs.join('&')
                                           },
                                           placeholder: '[queryParams]',
                                           template: config.getEnvironment().serverBaseURL +'/admin/payout-registry?[queryParams]',
                                       }  }
                    >Sales in period (#)</TableHeaderColumn>
                    <TableHeaderColumn width="60px"  formatExtraData={ {path:[  'SaleTransactionsTotalSum']}  }
                                       dataFormat={ priceFormatter } dataField='SaleTransactionsTotalSum'
                                       dataAlign="center"  >Sales in period ($)</TableHeaderColumn>
                    <TableHeaderColumn width="60px"  formatExtraData={ {path:[  'PendingSaleTransactionsTotalSum']}  }
                                       dataFormat={ priceFormatter } dataField='PendingSaleTransactionsTotalSum'
                                       dataAlign="center"  >Pending sales in period ($)</TableHeaderColumn>
                    <TableHeaderColumn width="60px"  formatExtraData={ {path:[  'PendingSaleTransactionsTotalProductCOGS']}  }
                                       dataFormat={ priceFormatter } dataField='PendingSaleTransactionsTotalProductCOGS'
                                       dataAlign="center" >Pending COGS in period ($)</TableHeaderColumn>
                    <TableHeaderColumn width="60px"  formatExtraData={ {path:[  'SoldSaleTransactionsTotalProductCOGS']}  }
                                       dataFormat={ priceFormatter } dataField='SoldSaleTransactionsTotalProductCOGS'
                                       dataAlign="center" >Sold COGS in period ($)</TableHeaderColumn>

                    <TableHeaderColumn dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                       hiddenOnInsert>Id</TableHeaderColumn>


                </BootstrapTable>

            </div>
        );
    }
}


export default AdminInventoryReconListTable;
